import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { enumDetailedInfoPlacementEnum, enumManualQuoteState } from '@app/data-layer/enums/lcl';
import { QuoteManualDetailedModel } from '@data-layer/models/lcl';

@Component({
  selector: 'app-lcl-dashboard-manual-quote-card',
  templateUrl: './lcl-dashboard-manual-quote-card.component.html',
  styleUrls: ['./lcl-dashboard-manual-quote-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclDashboardManualQuoteCardComponent {
  @Input() public quote: QuoteManualDetailedModel;

  public enumDetailedInfoPlacementEnum: typeof enumDetailedInfoPlacementEnum = enumDetailedInfoPlacementEnum;

  constructor() {}

  public get currentStatusText(): string {
    switch (this.quote?.status) {
      case enumManualQuoteState.NEW:
      case enumManualQuoteState.HANDLING:
      case enumManualQuoteState.QUOTED:
        return 'WAITING_FOR_OFFERS';

      case enumManualQuoteState.DENIED:
        return 'WAITING_FOR_OFFERS_DENIED';

      default:
        return 'WAITING_FOR_OFFERS';
    }
  }

  public get isDenied(): boolean {
    return this.quote?.status === enumManualQuoteState.DENIED;
  }
}
